__turbopack_context__.v({
  "breathe": "hv0hpG_breathe",
  "card": "hv0hpG_card",
  "card-rise": "hv0hpG_card-rise",
  "engraveBrand": "hv0hpG_engraveBrand",
  "engraveDefs": "hv0hpG_engraveDefs",
  "engraveEdition": "hv0hpG_engraveEdition",
  "engraveMark": "hv0hpG_engraveMark",
  "engraveText": "hv0hpG_engraveText",
  "flare": "hv0hpG_flare",
  "glare": "hv0hpG_glare",
  "glare-flow": "hv0hpG_glare-flow",
  "haze-bloom": "hv0hpG_haze-bloom",
  "haze-breathe": "hv0hpG_haze-breathe",
  "haze-flow": "hv0hpG_haze-flow",
  "layers": "hv0hpG_layers",
  "metal": "hv0hpG_metal",
  "metalBrush": "hv0hpG_metalBrush",
  "metalReflect": "hv0hpG_metalReflect",
  "play": "hv0hpG_play",
  "rise": "hv0hpG_rise",
  "sharp": "hv0hpG_sharp",
  "stage": "hv0hpG_stage",
});
